import styled from 'styled-components';

export const Container = styled.div`
  height: ${(props) => (props.isShare ? '100%' : 'calc(100% - 100px)')};
  width: 100%;
  position: absolute;
  z-index: 2;
`;
